import type { Router } from 'vue-router'
import { useSystemInfo } from '@admin/layouts/default/systemMenu/useSystemInfo'
import { useAddTab } from '@admin/layouts/default/tabs/useMultipleTabs'

export function createTabMenuGuard(router: Router) {
  const { judgeRouteInfo } = useSystemInfo()

  router.beforeEach(async (to, from, next) => {
    useAddTab(to, from)
    judgeRouteInfo(to)
    next()
  })

  // 使用 afterEach 处理首次加载时的菜单选中状态
  // 因为 beforeEach 时菜单数据可能还没初始化完成
  router.afterEach((to) => {
    judgeRouteInfo(to)
  })
}
